module.exports = __webpack_public_path__ + "img/stick_activites_rando_equestre2.268283d6.svg";